export const blue = "#080A38";
export const green = "#2FE090";
export const yellow = "#C6FBB5";
export const purple = "#566EFC";
export const grey = "#7f7f7f";
